export default __webpack_public_path__ + "static/media/icon-flight-post.cad2689c.svg";